module.exports = __webpack_public_path__ + "static/media/piper-dialog3-mobile-es.5c07b8f9.svg";